export default __webpack_public_path__ + "static/media/Joowon.5eb63d65.png";